import { Waves } from "@/svgs/images";
import { ReactNode } from "react";

export const WaveBorder = ({
  children,
  flip,
  animated,
  className,
  reverse,
}: {
  children?: ReactNode;
  flip?: boolean;
  reverse?: boolean;
  animated?: boolean;
  className?: string;
}) => {
  return (
    <div
      className={`wave-border${animated ? " animated" : ""}${
        reverse ? " reverse" : ""
      } bg-repeat-x flex flex-col w-full justify-end ${
        flip ? "bg-top -mb-[1px] -scale-y-100" : "bg-bottom -mt-[1px]"
      }${className ? ` ${className}` : ""}`}
      style={{
        backgroundImage: `url(${Waves.src})`,
        minHeight: Waves.height,
        marginBottom: "0",
      }}
    >
      <div
        className={`relative z-[1] ${flip ? "-scale-y-100" : ""} bg-primary`}
      >
        {children}
      </div>
    </div>
  );
};
